import apiBase from './ApiBase'

class ApiService {
  getRestrictions = () => apiBase.get('/restrictions')
}

const MedAireSecurityAPIService = new ApiService()

export default MedAireSecurityAPIService